export default __webpack_public_path__ + "static/media/snd_00008.ea0b86ee.mp4";